import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M18 15V18C18 18.55 17.55 19 17 19H3C2.45 19 2 18.55 2 18V6C2 5.45 2.45 5 3 5H15C15.55 5 16 5.45 16 6V9H21C21.55 9 22 9.45 22 10V14C22 14.55 21.55 15 21 15H18ZM20 13V11H4V13H20ZM16 15H4V17H16V15ZM14 9H4V7H14V9Z" fill={ fill || 'currentColor' } />
    </svg>
);
